// libs
import React, { memo, useState } from "react";

// global components
import ResponsiveLoader from "shared/components/ResponsiveLoader";
import Modal from "shared/components/Modal";

// components
import Login from "./components/Login";
import SignUp from "./components/SignUp";
import ForgotPassword from "./components/ForgotPassword";
import SocialLogin from "./components/SocialLogin";
import Separator from "./components/Separator";

// contexts
import AuthModalContext from "./AuthModalContext";

// constants
import { BREAKPOINTS } from "shared/styles/base";
import { FORM_STATE, FORM_TITLE } from "./constants";

// styles
import { AuthContainer, Title, modalCss } from "./styles";

// defs
interface IAuthModalProps {
    onHide: (value?: boolean) => void;
    redirectUrl?: string;
}

const Components = {
    [FORM_STATE.LOGIN]: <Login />,
    [FORM_STATE.SIGN_UP]: <SignUp />,
    [FORM_STATE.FORGOT_PASSWORD]: <ForgotPassword />,
};

function AuthModal({ onHide, redirectUrl }: IAuthModalProps) {
    const [formState, setFormState] = useState<FORM_STATE>(FORM_STATE.LOGIN);

    const onAuthSuccess = () => {
        if (redirectUrl !== undefined) {
            window.location.href = redirectUrl;
        }
    };

    return (
        <AuthModalContext.Provider value={{ setFormState, formState, onAuthSuccess }}>
            <Modal css={modalCss} onHide={onHide}>
                <AuthContainer data-cy="auth-modal">
                    {Components[formState]}
                    <Separator />
                    <SocialLogin />

                    <ResponsiveLoader breakpoint={BREAKPOINTS.MOBILE} down>
                        <Title data-test="auth-title">{FORM_TITLE[formState]}</Title>
                    </ResponsiveLoader>
                </AuthContainer>
            </Modal>
        </AuthModalContext.Provider>
    );
}

export default memo(AuthModal);
